import { DateShortcut } from '../../../components/FilterV3/components/DateRangeFilterV2/dateRangeFilter.types';
import { ORDERS_FILTERS_KEYS } from '../../../modules/orders/orderFilter/orderFilter.utils';
import { queryClient } from '../../../modules/reactQuery/contexts/QueryClient/utils/queryClient';
import { REPORTS_FILTERS_KEYS } from '../../../modules/reports/reports-page/components/ReportsFiltersHandler/components/InvoicingAndSalesReportsFilter/invoicingAndSalesReportsFilter.utils';
import { getFindUserContextPreferencesKey } from './userContextPreferences.keys';
import {
  FilterPreferenceRecognizedLists,
  PreservationRuleProps,
  UpdateOrCreateFilterPreferenceInput,
  UserContextPreferences,
} from './userContextPreferences.types';

const PRESERVATION_RULES: Partial<
  Record<FilterPreferenceRecognizedLists, PreservationRuleProps[]>
> = {
  [FilterPreferenceRecognizedLists.ORDERS]: [
    {
      field: ORDERS_FILTERS_KEYS.dateShortcut,
      conditionValue: DateShortcut.ALL_PERIOD,
      dependentFields: [ORDERS_FILTERS_KEYS.startCreationDate, ORDERS_FILTERS_KEYS.endCreationDate],
    },
  ],
  [FilterPreferenceRecognizedLists.SALES_REPORTS]: [
    {
      field: REPORTS_FILTERS_KEYS.dateShortcut,
      conditionValue: DateShortcut.ALL_PERIOD,
      dependentFields: [
        REPORTS_FILTERS_KEYS.createdAtStartDate,
        REPORTS_FILTERS_KEYS.createdAtEndDate,
      ],
    },
  ],
  [FilterPreferenceRecognizedLists.SELLOUT_SALES_REPORTS]: [
    {
      field: REPORTS_FILTERS_KEYS.dateShortcut,
      conditionValue: DateShortcut.ALL_PERIOD,
      dependentFields: [
        REPORTS_FILTERS_KEYS.createdAtStartDate,
        REPORTS_FILTERS_KEYS.createdAtEndDate,
      ],
    },
  ],
  [FilterPreferenceRecognizedLists.INVOICING_REPORTS]: [
    {
      field: REPORTS_FILTERS_KEYS.dateShortcut,
      conditionValue: DateShortcut.ALL_PERIOD,
      dependentFields: [
        REPORTS_FILTERS_KEYS.createdAtStartDate,
        REPORTS_FILTERS_KEYS.createdAtEndDate,
      ],
    },
  ],
  [FilterPreferenceRecognizedLists.SUPPLIER_SALES_REPORTS]: [
    {
      field: REPORTS_FILTERS_KEYS.dateShortcut,
      conditionValue: DateShortcut.ALL_PERIOD,
      dependentFields: [
        REPORTS_FILTERS_KEYS.createdAtStartDate,
        REPORTS_FILTERS_KEYS.createdAtEndDate,
      ],
    },
  ],
};

export const formatUserContextFiltersToSave = (
  input: UpdateOrCreateFilterPreferenceInput,
  teamId?: string,
): UpdateOrCreateFilterPreferenceInput => {
  const rules = PRESERVATION_RULES[input.list];

  if (!rules || rules?.length === 0) {
    return input;
  }

  const oldUserPreferences = queryClient.getQueryData<UserContextPreferences | null>([
    teamId,
    ...getFindUserContextPreferencesKey(),
  ]);

  const oldUserPreferencesCurrentList = oldUserPreferences?.filterPreferences?.find(
    (preference) => preference.list === input.list,
  );

  if (!oldUserPreferencesCurrentList) {
    return input;
  }
  const inputFormatted = { ...input };

  rules.forEach((rule) => {
    if (inputFormatted.defaultFilters[rule.field] === rule.conditionValue) {
      inputFormatted.defaultFilters[rule.field] =
        oldUserPreferencesCurrentList.defaultFilters[rule.field];

      rule.dependentFields?.forEach((field) => {
        inputFormatted.defaultFilters[field] = oldUserPreferencesCurrentList.defaultFilters[field];
      });
    }
  });

  return inputFormatted;
};
